import { userSelector } from '@/core/store/user/userSlice';
import { useAppSelector } from '@/hooks';
import { AvatarWithDropdown } from './Participants/AvatarWithDropdown';
import { getColor } from './Participants/Participants.helpers';
import { CompanyUser } from '@/core/types';

interface Props {
  users: CompanyUser[];
}

export const AvatarsChain = ({ users }: Props) => {
  const user = useAppSelector(userSelector);
  const itemWidth = 32;
  if (!user) return null;
  return (
    <div
      className='relative flex justify-end'
      style={{
        width: itemWidth * (users.length + 1) - (itemWidth / 2) * users.length,
      }}
    >
      {users.map((u, index) => (
        <div
          key={index}
          className='absolute h-8 w-8'
          style={{
            left: index * (itemWidth - 16),
          }}
        >
          <AvatarWithDropdown
            className='flex-shrink-0 text-sm'
            data={u}
            backgroundColor={getColor(u.Name)}
            testId={`AvatarsChain-user-${u.Id}`}
          />
        </div>
      ))}
      <AvatarWithDropdown
        className='flex-shrink-0 text-sm'
        data={user}
        backgroundColor={getColor(user.Name)}
        testId={`AvatarsChain-user-${user.Id}`}
        isUser={true}
      />
    </div>
  );
};
